module.exports = __webpack_public_path__ + "img/landing-page-2.6469de91.webp";